import {ViewMode} from '../../ui/components/common/data/DataView';
import {IToggleViewAction} from '../actions/types/view.types';
import {TOGGLE_VIEW_GRID, TOGGLE_VIEW_TABLE} from '../actions/view';

export interface ViewReducerState {
    presentationView: ViewMode;
}

export const viewReducerPreloadedState = {
    presentationView: ViewMode.TABLE,
};

export const viewReducer = (state: ViewReducerState = viewReducerPreloadedState, action: IToggleViewAction): ViewReducerState => {
    switch (action.type) {
        case TOGGLE_VIEW_GRID:
            return {...state, presentationView: ViewMode.GRID};
        case TOGGLE_VIEW_TABLE:
            return {...state, presentationView: ViewMode.TABLE};
        default:
            return state;
    }
};
